module.exports = __webpack_public_path__ + "static/media/groovy.4026c71d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/groovy.svg
// module id = 525
// module chunks = 0